
export default {
  orsLPolyline: {
    type: 'Tipo',
    surface: 'Superfície',
    unknownSurfaceType: 'Desconhecido'
  }
}
